import { render, staticRenderFns } from "./BuyBoxUpcomingOfferNew.vue?vue&type=template&id=6cf91fd6&scoped=true"
import script from "./BuyBoxUpcomingOfferNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxUpcomingOfferNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxUpcomingOfferNew.vue?vue&type=style&index=0&id=6cf91fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf91fd6",
  null
  
)

export default component.exports